<template>
  <!-- 个人信息 -->
  <div class="app-container">
    <ContainerFull body-color="transparent" padding-val="0">
      <el-form v-loading="detailLoading" :model="editForm" ref="editForm" label-width="100px" disabled>
        <el-tabs type="border-card" v-model="activeName">
          <el-tab-pane label="基本信息" name="one">
            <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
              <el-col :span="16">
                <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
                  <el-col :span="12">
                    <el-form-item label="姓名" prop="name">
                      <el-input v-model="editForm.name" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="登录账号" prop="loginName">
                      <el-input v-model="editForm.loginName" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="手机号码" prop="mobile">
                      <el-input v-model="editForm.mobile" onkeyup="value=value.replace(/[^\d-]/g,'')" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="所属部门" prop="deptName">
                      <el-input v-model="editForm.deptName" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="岗位" prop="t4">
                      <el-select v-model="editForm.t4" clearable>
                        <el-option
                          v-for="item in t4Options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="状态" prop="deleted">
                      <el-switch
                        v-model="editForm.deleted"
                        :active-value="0"
                        :inactive-value="1"
                        active-text="在职"
                        inactive-text="离职"
                      ></el-switch>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="入职时间" prop="joinTime">
                      <el-date-picker
                        type="date"
                        value-format="yyyy-MM-dd"
                        v-model="editForm.joinTime"
                        style="width: 100%"
                        clearable
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="角色" prop="roleIdArray">
                      <el-select v-model="editForm.roleIdArray" multiple clearable>
                        <el-option v-for="item in roleOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="身份证号" prop="idcard">
                      <el-input v-model="editForm.idcard" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="出生日期" prop="birthday">
                      <el-date-picker
                        v-model="editForm.birthday"
                        type="date"
                        value-format="yyyy-MM-dd"
                        clearable
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="性别">
                      <el-input v-model="editForm.sex" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="政治面貌" prop="politstatus">
                      <el-input v-model="editForm.politstatus" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="籍贯" prop="birthplace">
                      <el-input v-model="editForm.birthplace" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="民族" prop="nation">
                      <el-input v-model="editForm.nation" clearable></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>

              <el-col :span="8">
                <div>
                  <el-form-item label="电子签名">
                    <el-image
                      v-if="editForm.signature"
                      style="width: 150px; height: 150px"
                      :src="$imgUrl + editForm.signature"
                      :preview-src-list="[$imgUrl + editForm.signature]"
                      fit="scale-down"
                    ></el-image>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <!-- <el-tab-pane label="劳动合同" name="two">
            <el-table
              :data="userTags6"
              height="calc(100% - 50px)"
              border
              stripe
              :header-cell-style="{ background: '#f2f2f2', color: '#101010' }"
              style="width: 100%"
            >
              <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
              <el-table-column label="签订时间" align="center">
                <template v-slot="{ $index }">
                  <el-date-picker
                    type="date"
                    clearable
                    value-format="yyyy-MM-dd"
                    v-model="userTags6[$index]['tagstarttime']"
                    style="width: 100%"
                  ></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="到期时间" align="center">
                <template v-slot="{ $index }">
                  <el-date-picker
                    type="date"
                    clearable
                    value-format="yyyy-MM-dd"
                    v-model="userTags6[$index]['tagendtime']"
                    style="width: 100%"
                  ></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="附件" align="center">
                <template v-slot="{ $index }">
                  <el-link
                    v-if="userTags6[$index]['tagpic']"
                    type="primary"
                    :underline="false"
                    :href="$imgUrl + userTags6[$index]['tagpic']"
                    target="_blank"
                  >
                    {{ userTags6[$index]['tagpic'].split('/').pop() }}
                  </el-link>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="家庭成员" name="three">
            <el-table
              :data="userTags0"
              height="calc(100% - 50px)"
              border
              stripe
              :header-cell-style="{ background: '#f2f2f2', color: '#101010' }"
              style="width: 100%"
            >
              <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
              <el-table-column label="姓名" align="center">
                <template v-slot="{ $index }">
                  <el-input v-model="userTags0[$index]['tagname']"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="关系" align="center">
                <template v-slot="{ $index }">
                  <el-input v-model="userTags0[$index]['tagtype']"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="出生年月" align="center">
                <template v-slot="{ $index }">
                  <el-input v-model="userTags0[$index]['tagtime']"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="联系方式" align="center">
                <template v-slot="{ $index }">
                  <el-input v-model="userTags0[$index]['taglevel']"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="教育情况" name="four">
            <el-table
              :data="userTags1"
              height="calc(100% - 50px)"
              border
              stripe
              :header-cell-style="{ background: '#f2f2f2', color: '#101010' }"
              style="width: 100%"
            >
              <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
              <el-table-column label="起始时间" align="center">
                <template v-slot="{ $index }">
                  <el-date-picker
                    type="date"
                    clearable
                    value-format="yyyy-MM-dd"
                    v-model="userTags1[$index]['tagstarttime']"
                    style="width: 100%"
                  ></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="截止时间" align="center">
                <template v-slot="{ $index }">
                  <el-date-picker
                    type="date"
                    clearable
                    value-format="yyyy-MM-dd"
                    v-model="userTags1[$index]['tagendtime']"
                    style="width: 100%"
                  ></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="就读院校" align="center">
                <template v-slot="{ $index }">
                  <el-input v-model="userTags1[$index]['tagname']"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="专业" align="center">
                <template v-slot="{ $index }">
                  <el-input v-model="userTags1[$index]['taglevel']"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="学历" align="center">
                <template v-slot="{ $index }">
                  <el-input v-model="userTags1[$index]['taglevel']"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="学位" align="center">
                <template v-slot="{ $index }">
                  <el-input v-model="userTags1[$index]['tagremark']"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="入职前工作经历" name="seven">
            <el-table
              :data="userTags4"
              height="calc(100% - 50px)"
              border
              stripe
              :header-cell-style="{ background: '#f2f2f2', color: '#101010' }"
              style="width: 100%"
            >
              <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>

              <el-table-column label="工作单位" align="center">
                <template v-slot="{ $index }">
                  <el-input v-model="userTags4[$index]['tagname']"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="工作岗位" align="center">
                <template v-slot="{ $index }">
                  <el-input v-model="userTags4[$index]['tagtype']"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="开始时间" align="center">
                <template v-slot="{ $index }">
                  <el-date-picker
                    type="date"
                    clearable
                    value-format="yyyy-MM-dd"
                    v-model="userTags4[$index]['tagstarttime']"
                    style="width: 100%"
                  ></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="结束时间" align="center">
                <template v-slot="{ $index }">
                  <el-date-picker
                    type="date"
                    clearable
                    value-format="yyyy-MM-dd"
                    v-model="userTags4[$index]['tagendtime']"
                    style="width: 100%"
                  ></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="备注" align="center">
                <template v-slot="{ $index }">
                  <el-input v-model="userTags4[$index]['tagremark']"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="入职后工作经历" name="eight">
            <el-table
              :data="userTags5"
              height="calc(100% - 50px)"
              border
              stripe
              :header-cell-style="{ background: '#f2f2f2', color: '#101010' }"
              style="width: 100%"
            >
              <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>

              <el-table-column label="工作单位" align="center">
                <template v-slot="{ $index }">
                  <el-input v-model="userTags5[$index]['tagname']"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="工作岗位" align="center">
                <template v-slot="{ $index }">
                  <el-input v-model="userTags5[$index]['tagtype']"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="开始时间" align="center">
                <template v-slot="{ $index }">
                  <el-date-picker
                    type="date"
                    clearable
                    value-format="yyyy-MM-dd"
                    v-model="userTags5[$index]['tagstarttime']"
                    style="width: 100%"
                  ></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="结束时间" align="center">
                <template v-slot="{ $index }">
                  <el-date-picker
                    type="date"
                    clearable
                    value-format="yyyy-MM-dd"
                    v-model="userTags5[$index]['tagendtime']"
                    style="width: 100%"
                  ></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="备注" align="center">
                <template v-slot="{ $index }">
                  <el-input v-model="userTags5[$index]['tagremark']"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane> -->
        </el-tabs>
      </el-form>

      <template v-slot:footer>
        <el-button @click="$goBack()">关闭</el-button>
      </template>
    </ContainerFull>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ContainerFull from '@/components/ContainerFull';

import { getRoleList } from '@/api/user';

export default {
  components: { ContainerFull },
  props: {},
  data() {
    return {
      activeName: 'one',
      editForm: {
        deleted: 0,
        roleIdArray: []
      },
      t4Options: [
        {
          value: '主任',
          label: '主任'
        },
        {
          value: '副主任',
          label: '副主任'
        }
      ],
      roleOptions: [],
      userTags0: [], //家庭成员
      userTags1: [], //教育情况
      userTags4: [], //入职前工作经历
      userTags5: [], //入职后工作经历
      userTags6: [], //劳动合同
      detailLoading: false
    };
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  watch: {
    userInfo: {
      handler(data) {
        if (data.id) {
          this.detailLoading = true;
          this.getRoleList();

          const roleIdArray = data?.roleIds ? data.roleIds.split(',') : [];
          this.editForm = { ...data, roleIdArray };
          this.fileListSignature = (data?.signature ? data.signature.split(',') : []).map(item => ({
            name: item,
            url: item
          }));

          this.userTags0 = data.userTags0 || [];
          this.userTags1 = data.userTags1 || [];
          this.userTags4 = data.userTags4 || [];
          this.userTags5 = data.userTags5 || [];
          this.userTags6 = data.userTags6 || [];
          this.detailLoading = false;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 获取角色列表
    async getRoleList() {
      const { data } = await getRoleList({ pageNum: 1, pageSize: 9999 });

      this.roleOptions = data.list || [];
    }
  },
  created() {},
  mounted() {},
  async activated() {
    await this.$store.dispatch('user/getUserInfo');
  } //页面有keep-alive触发
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 0;
}

.el-form {
  height: 100%;

  .el-select,
  .el-cascader,
  .el-input {
    width: 100%;
  }
}

::v-deep .el-tabs {
  height: 100%;

  .el-tabs__content {
    height: calc(100% - 40px);

    .el-tab-pane {
      height: 100%;
      overflow: hidden;
      overflow-y: auto;
    }
  }
}

.el-image {
  border: 1px dashed #c0ccda;
}
</style>
